<template>
  <span v-if="hasAnyIds">
    <external-id-tag
      v-if="paper.externalidsACL"
      tag-name="ACL"
      :tag-value="paper.externalidsACL"
      :link="getLink('ACL', paper.externalidsACL)"
    />
    <external-id-tag
      v-if="paper.externalidsArXiv"
      tag-name="ArXiv"
      :tag-value="paper.externalidsArXiv"
      :link="getLink('ArXiv', paper.externalidsArXiv)"
    />
    <external-id-tag
      v-if="paper.externalidsCorpusId"
      tag-name="Semantic Scholar"
      :tag-value="paper.externalidsCorpusId"
      :link="getLink('Semantic Scholar', paper.url)"
    />
    <external-id-tag
      v-if="paper.externalidsDBLP"
      tag-name="DBLP"
      :tag-value="paper.externalidsDBLP"
      :link="getLink('DBLP', paper.externalidsDBLP)"
    />
    <external-id-tag
      v-if="paper.externalidsDOI"
      tag-name="DOI"
      :tag-value="paper.externalidsDOI"
      :link="getLink('DOI', paper.externalidsDOI)"
    />
    <external-id-tag
      v-if="paper.externalidsPubMed"
      tag-name="PubMed"
      :tag-value="paper.externalidsPubMed"
      :link="getLink('PubMed', paper.externalidsPubMedC)"
    />
    <external-id-tag
      v-if="paper.externalidsPubMedCentral"
      tag-name="PubMed Central"
      :tag-value="paper.externalidsPubMedCentral"
      :link="getLink('PubMed Central', paper.externalidsPubMedCentral)"
    />
    <external-id-tag
      v-if="paper.openalexData && paper.openalexData.id"
      tag-name="OpenAlex"
      :tag-value="paper.openalexData.id.replace('https://openalex.org/', '')"
      :link="getLink('OpenAlex', paper.openalexData.id)"
    />
  </span>
</template>

<script>
import ExternalIdTag from "./ExternalIdTag.vue";

export default {
  components: {
    ExternalIdTag,
  },
  props: {
    paper: Object,
  },
  computed: {
    hasAnyIds() {
      return (
        this.paper.externalidsACL ||
        this.paper.externalidsArXiv ||
        this.paper.externalidsCorpusId ||
        this.paper.externalidsDBLP ||
        this.paper.externalidsDOI ||
        this.paper.externalidsPubMed ||
        this.paper.externalidsPubMedCentral ||
        (this.paper.openalexData && this.paper.openalexData.id)
      );
    },
  },
  methods: {
    getLink(idType, id) {
      switch (idType) {
        case "ACL":
          return `https://aclanthology.org/${id}`;
        case "ArXiv":
          return `https://arxiv.org/abs/${id}`;
        case "Semantic Scholar":
          return `${id}`;
        case "DBLP":
          return `https://dblp.org/rec/${id}`;
        case "DOI":
          return `https://doi.org/${id}`;
        case "PubMed":
          return `https://pubmed.ncbi.nlm.nih.gov/${id}`;
        case "PubMed Central":
          return `https://www.ncbi.nlm.nih.gov/pmc/articles/${id}`;
        case "OpenAlex":
          return id;
        default:
          return null;
      }
    },
  },
};
</script>
